var map = {
	"./0.png": 61086,
	"./1.png": 48775,
	"./10.png": 48231,
	"./11.png": 72446,
	"./12.png": 9173,
	"./13.png": 97548,
	"./14.png": 46947,
	"./15.png": 40762,
	"./16.png": 17009,
	"./17.png": 68616,
	"./18.png": 32031,
	"./2.png": 80300,
	"./3.png": 46837,
	"./4.png": 88890,
	"./5.png": 10467,
	"./6.png": 57256,
	"./7.png": 13553,
	"./8.png": 85718,
	"./9.png": 63807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68607;